import React, { FC, useEffect, useRef, useState } from 'react';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { useMutation } from 'react-query';
import { red } from '@mui/material/colors';
import EmailIcon from '@mui/icons-material/Email';
import Form, { ResetFormHandler } from '../Form/Form';
import { SUBMIT_BTN_TYPE, contactUsFields } from '../Form/form.utils';
import { ContactUsDTO } from '../../lib/interfaces/ContactUs';
import { FormField } from '../../lib/interfaces/Form';
import { contactUs } from '../../api/apiRequests/contactUs';
import './ContactUsPage.scss';
import './ContactUsForm.scss';
import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';

const ContactUsForm: FC = () => {
	const { t } = useTranslation();
	const { data: currentUser } = useUserMeQuery();
	const [showForm, setShowForm] = useState<boolean>(false);
	const [showContactUsError, setShowContactUsError] = useState<boolean>(false);
	const [showContactUsSuccess, setSowContactUsSuccess] =
		useState<boolean>(false);
	const childRef = useRef<ResetFormHandler>(null);

	const contactUsFormFields =
		showForm &&
		contactUsFields.map((field: FormField) => {
			if (field.label) {
				field.label = t(field.label);
			}

			if (currentUser) {
				if (field.name === 'contactName') {
					field.init = `${currentUser.firstName} ${currentUser.lastName}`;
				}
				if (field.name === 'contactEmail') {
					field.init = currentUser.email;
				}
			}
			return field;
		});

	useEffect(() => {
		if (currentUser !== undefined) {
			setShowForm(true);
		}
	}, [currentUser]);

	const contactUsMutation = useMutation<any, AxiosError<any>, ContactUsDTO>(
		(data: ContactUsDTO) => contactUs(data),
		{
			onSuccess() {
				setSowContactUsSuccess(true);
				setShowContactUsError(false);
				childRef?.current?.reset();
			},
			onError: () => {
				setSowContactUsSuccess(false);
				setShowContactUsError(true);
			},
		},
	);

	const handleSubmit = (formValuesCP: ContactUsDTO) => {
		contactUsMutation.mutate(formValuesCP);
	};
	return (
		<div>
			{showForm && contactUsFormFields && (
				<div className="ContactUsForm">
					<Form
						fields={contactUsFormFields}
						onSubmit={handleSubmit}
						saveButtonName={t('send')}
						saveButtonStyle={SUBMIT_BTN_TYPE.INHERIT}
						ref={childRef}
						fullWidth
					/>
				</div>
			)}
			{showContactUsError && (
				<Typography
					component="p"
					variant="body1"
					color={red[500]}
					sx={{ marginTop: '20px' }}
				>
					{t('contactUsFormError')}
				</Typography>
			)}
			{showContactUsSuccess && (
				<Typography
					className="ContactUs__success-message"
					component="p"
					variant="body1"
					sx={{ marginTop: '20px' }}
				>
					<EmailIcon sx={{ marginRight: '5px' }} />
					{t('contactUsFormdSuccess')}
				</Typography>
			)}
		</div>
	);
};

export default ContactUsForm;
